import _ from 'lodash';

export const getRoleDescription = (role: string) => {
  const currentRole = _.snakeCase(_.lowerCase(role));
  switch (currentRole) {
    case 'church_admin':
      return '';
    case 'content_creator':
      return 'This user can create Study Programs and Events.';
    case 'event_leader':
      return '';
    case 'studier':
      return 'This user can only experience content from the Risen Hope Mobile App.';
    case 'system_admin':
      return '';
    default:
      return '';
  }
};
